import { AfterViewInit, Component, EventEmitter, Input, Output } from "@angular/core";
import { CandidateMeetingModel, ConfirmSelfSelectMeetingModel, CronofyDateSelectedNotification, CronofyNotification, CronofySlotSelectedNotification, DeclineInterviewRequest, InterviewDashboardResult, InterviewerModel } from "../../../interviews.models";
import { InterviewStatus } from "../../../interviews.enums";
import { HttpService } from "src/app/services/http.service";
import { ErrorService } from "src/app/services/error.service";
import { ErrorHandlerService } from "src/app/services/error-handler.service";
import { InterviewsService } from "../../../services/interviews.service";

@Component({
    selector: 'interview-details-individual-select',
    templateUrl: './interview-details-individual-select.component.html',
    standalone: false
})
export class InterviewDetailsIndividualSelectComponent implements AfterViewInit{
  @Input() meeting?: CandidateMeetingModel;
  @Input() interviewers: InterviewerModel[] = [];
  @Input() dashboardInfo: InterviewDashboardResult | null = null;

  @Output() onBackButtonClicked: EventEmitter<void> = new EventEmitter();
  @Output() onDeclineInterviewClicked: EventEmitter<DeclineInterviewRequest> = new EventEmitter();
  @Output() onSlotSelected: EventEmitter<ConfirmSelfSelectMeetingModel> = new EventEmitter();

  public InterviewStatus = InterviewStatus;

  constructor(
    private httpService: HttpService,
    private errorHandler: ErrorHandlerService,
    private interviewsService: InterviewsService) {}

  ngAfterViewInit(): void {
    if (this.meeting) {
      this.initDatePicker()
    }
  }

  public initDatePicker(){
    // For some reason this only works on local when in incognito. If anyone figures out why, let me know
    const _global = window as any;
    const self = this;
    if (_global.CronofyElements && typeof(_global.CronofyElements.DateTimePicker) === 'function'){
      this.httpService.authenticateCronofyElementToken(this.meeting!.id).subscribe({
        next: result => {
          const periods = JSON.parse(result.availabilityQueryJson);

          _global.CronofyElements.DateTimePicker({
            element_token: result.elementToken,
            target_id: "cronofy-date-time-picker",
            data_center: 'uk',
            availability_query: {
              participants: [
                {
                  required: "all",
                  members: JSON.parse(result.membersJson)
                }
              ],
              required_duration: { minutes: result.duration },
              query_periods: periods['query_periods'],
              buffer: {
                before: { minutes : result.buffer},
                after: { minutes : result.buffer}
              },
              response_format: result.responseFormat,
              start_interval: {minutes: result.startInterval}
            },
            styles: {
              prefix: "talos-dp",
            },
            callback: (notification: any) => this.notificationReceivedFromCronofy.apply(self, [notification.notification as CronofyNotification])
            // using apply cause the context of this gets lost since the cronofy stuff is written in some very silly ancient language known as 'Java-script'
          });
        },
        error: err => {
          this.errorHandler.handleError(err);
        }
    });
    }
  }

  public notificationReceivedFromCronofy(notification: CronofyNotification) {
    switch(notification.type) {
      case 'date_selected':
        this.dateSelected(notification as CronofyDateSelectedNotification);
        break;
      case 'slot_selected':
        this.slotSelected(notification as CronofySlotSelectedNotification);
        break;
      case 'no_slots_found':
        this.noSlotsFound();
        break;
    }
  }

  public dateSelected(notification: CronofyDateSelectedNotification) {
    //console.log('date selected', notification);
  }

  public slotSelected(notification: CronofySlotSelectedNotification){
    //console.log('slot selected', notification);
    this.onSlotSelected.emit({slot: notification.slot, meeting: this.meeting!});
  }

  public noSlotsFound(){
    //console.log('no slots found');
  }

  public back() {
    this.onBackButtonClicked.emit();
  }

  public declineInterview(model: DeclineInterviewRequest){
    this.onDeclineInterviewClicked.emit(model);
  }

  public meetingInThePast(meeting: CandidateMeetingModel): boolean {
    return this.interviewsService.meetingInThePast(meeting);
  }  
}
